import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'mr',
  months: [
    'जानेवारी',
    'फेब्रुवारी',
    'मार्च',
    'एप्रिल',
    'मे',
    'जून',
    'जुलै',
    'ऑगस्ट',
    'सप्टेंबर',
    'ऑक्टोबर',
    'नोव्हेंबर',
    'डिसेंबर',
  ],
  monthsShort: ['जाने', 'फेब्रु', 'मार्च', 'एप्रि', 'मे', 'जून', 'जुलै', 'ऑग', 'सप्टें', 'ऑक्टो', 'नोव्हें', 'डिसें'],
  weekdays: ['रविवार', 'सोमवार', 'मंगळवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
  weekdaysMin: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  weekdaysShort: ['रवि', 'सोम', 'मंगळ', 'बुध', 'गुरू', 'शुक्र', 'शनि'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY, H:mm',
    'LLL-Y': 'D MMMM, H:mm',
    LLLL: 'dddd, D MMMM, YYYY, H:mm',
    'LLLL-Y': 'dddd D MMMM, H:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM, YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D, MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s वर्षापूर्वी', other: '%s वर्षांपूर्वी' },
    M: { one: '%s महिन्यापूर्वी', other: '%s महिन्यांपूर्वी' },
    w: { one: '%s आठवड्यापूर्वी', other: '%s आठवड्यांपूर्वी' },
    d: { one: '%s दिवसापूर्वी', other: '%s दिवसांपूर्वी' },
    h: { one: '%s तासापूर्वी', other: '%s तासांपूर्वी' },
    m: { one: '%s मिनि. पूर्वी', other: '%s मिनि. पूर्वी' },
    s: { one: '%s से. पूर्वी', other: '%s से. पूर्वी' },
  },
  future: {
    y: { one: '%s वर्षामध्ये', other: '%s वर्षांमध्ये' },
    M: { one: '%s महिन्यामध्ये', other: '%s महिन्यामध्ये' },
    w: { one: 'येत्या %s आठवड्यामध्ये', other: 'येत्या %s आठवड्यांमध्ये' },
    d: { one: '%s दिवसामध्ये', other: 'येत्या %s दिवसांमध्ये' },
    h: { one: '%s तासामध्ये', other: '%s तासांमध्ये' },
    m: { one: '%s मिनि. मध्ये', other: '%s मिनि. मध्ये' },
    s: { one: '%s से. मध्ये', other: '%s से. मध्ये' },
  },
  pastLong: {
    y: { one: '%s वर्षापूर्वी', other: '%s वर्षांपूर्वी' },
    M: { one: '%s महिन्यापूर्वी', other: '%s महिन्यांपूर्वी' },
    w: { one: '%s आठवड्यापूर्वी', other: '%s आठवड्यांपूर्वी' },
    d: { one: '%s दिवसापूर्वी', other: '%s दिवसांपूर्वी' },
    h: { one: '%s तासापूर्वी', other: '%s तासांपूर्वी' },
    m: { one: '%s मिनिटापूर्वी', other: '%s मिनिटांपूर्वी' },
    s: { one: '%s सेकंदापूर्वी', other: '%s सेकंदांपूर्वी' },
  },
  futureLong: {
    y: { one: 'येत्या %s वर्षामध्ये', other: 'येत्या %s वर्षांमध्ये' },
    M: { one: 'येत्या %s महिन्यामध्ये', other: 'येत्या %s महिन्यांमध्ये' },
    w: { one: '%s आठवड्यामध्ये', other: '%s आठवड्यांमध्ये' },
    d: { one: 'येत्या %s दिवसामध्ये', other: 'येत्या %s दिवसांमध्ये' },
    h: { one: '%s तासामध्ये', other: '%s तासांमध्ये' },
    m: { one: '%s मिनिटामध्ये', other: '%s मिनिटांमध्ये' },
    s: { one: '%s सेकंदामध्ये', other: '%s सेकंदांमध्ये' },
  },
  abbr: {
    y: { one: '%sवर्ष', other: '%sवर्षे' },
    M: { one: '%sम', other: '%sम' },
    w: { one: '%sआ', other: '%sआ' },
    d: { one: '%sदि', other: '%sदि' },
    h: { one: '%sता', other: '%sता' },
    m: { one: '%sमि', other: '%sमि' },
    s: { one: '%sसे', other: '%sसे' },
  },
  full: {
    y: { one: '%s वर्ष', other: '%s वर्षे' },
    M: { one: '%s महिना', other: '%s महिने' },
    w: { one: '%s आठवडा', other: '%s आठवडे' },
    d: { one: '%s दिवस', other: '%s दिवस' },
    h: { one: '%s तास', other: '%s तास' },
    m: { one: '%s मिनिट', other: '%s मिनिटे' },
    s: { one: '%s सेकंद', other: '%s सेकंद' },
  },
  justNow: 'आत्ताच',
  yesterday: 'काल',
  today: 'आज',
  tomorrow: 'उद्या',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM, YYYY', end: 'ddd, D MMM, YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM, YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM, YYYY, H:mm', end: 'D MMM, YYYY, H:mm' },
    mt: { start: 'D MMM, H:mm', end: 'D MMM, H:mm' },
    dt: { start: 'D MMM, H:mm', end: 'D MMM, H:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM, YYYY, H:mm', end: 'D MMM, YYYY, H:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, H:mm', end: 'D MMM, H:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, H:mm', end: 'D MMM, H:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'mr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
